import { LOADING, STATUS_CODE_SUCCESS } from "../../../constants/constant";
import {
  SUBMIT_BOT_SUMMARY,
  SUBMIT_BOT_SUMMARY_SUCCESS,
  SUBMIT_BOT_SUMMARY_FAILED,
} from "../../actions/ActionType";

const initialState = {
  status: "",
  isLoading: false,
};

export default function submitBotSummary(state = initialState, action) {
  switch (action.type) {
    case SUBMIT_BOT_SUMMARY:
      let reqstState = Object.assign({}, state);
      reqstState.isLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case SUBMIT_BOT_SUMMARY_SUCCESS:
      let userRes = Object.assign({}, state);
      console.log("came to the submitBotSummary success", action);
      userRes.status = action.data.status_message;
      userRes.isLoading = false;
      userRes.statusCode = action.data.status_code;

      if (userRes.statusCode !== STATUS_CODE_SUCCESS) {
        userRes.error = true;
        userRes.errorMessage = action.data.message;
        return userRes;
      }
      userRes.entity = action.data.status_message;
      userRes.error = false;

      return userRes;

    case SUBMIT_BOT_SUMMARY_FAILED:
      return Object.assign({}, state, action.error);

    default:
      return state;
  }
}
